import React from 'react';
import Footer from '../../common/Footer';

const HomeFooter = () => {
  return <Footer />;
};

export default HomeFooter;
